import DEV_ENV_PARAMS from '../environments/development';
import PROD_ENV_PARAMS from '../environments/production';

export const PARAM_USER_CREATED = "user_created=true";
export const PARAM_RESOURCE_INFO_KEY = "resource";
export const VALUE_REDIRECT_ON_USER_EXIST = "redirect-on-user-exist";
export const PARAM_REDIRECT_ON_USER_EXIST = PARAM_RESOURCE_INFO_KEY + "=" + VALUE_REDIRECT_ON_USER_EXIST;
export const VALUE_LOGIN = "login"
export const PARAM_LOGIN = PARAM_RESOURCE_INFO_KEY + "=" + VALUE_LOGIN;
export const PARAM_BACKGROUND_KEY = "in_background";
export const PARAM_HIDE_ERROR_MODAL = "hide-error";
export const PARAM_HIDE_LOADING = "hide-loading";

const envParams = process.env.NODE_ENV == 'production' ? PROD_ENV_PARAMS : DEV_ENV_PARAMS;

export const BASE_URL = envParams.BASE_URL;

export const BASE_WS_URL = envParams.BASE_WS_URL;

export const ZOOM_API_BASE_URL = envParams.BASE_URL;



// WEBPACK FOOTER //
// ./src/constants/url-params.js